<div class="em-address-book-auto-complete-tree-container mat-elevation-z4"
    fxFlex>
    <em-address-book-tree fxFlex
        [visableEnabled]="true"
        [badgeHidden]="true"
        [root]="root"
        (itemClicked)="onItemClicked($event)"
        #addressbooktree></em-address-book-tree>
</div>